import styled from "styled-components";

const ContentDiv = styled.div`
  font-weight: 500;
  font-size: 1em;
`;

export default ContentDiv;
